import { generateQueryUri } from '../utils/uri';
import $http from '../utils/http-common';
const FormData = require('form-data');

export default class Request {
  async post(path, body = {}, config) {

    return $http(config?.baseURL)
      .post(path, body, config)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(({ response }) => {
        return Promise.reject(response);
      });
  }

  async upload(path, file, config) {
    let data = new FormData();
    data.append('file', file);

    return $http(config?.baseURL, {})
      .post(path, data, config)
      .then((response) => Promise.resolve(response))
      .catch(({ response }) => Promise.reject(response));
  }

  /**
   *
   * @param {string} path - base url
   * @param {object} params - every parameter will be converted as a querystring
   * @param {object} config - header, data, etc...   `config` is the config that was provided to `Vue.$http` for the request
   * @return {Q.Promise<Q.Promise<never> | * | Promise<T | never>>}
   *
   */

  //
  // const params = { foo: 'foo', moo: 'moo' }
  // const config = {
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   data: {} data must be added otherwise will be caused a problem
  // };
  //
  // request.get( 'custom-endpoint', params , config );
  //

  async get(path, params, config = {}) {
    if (params) {
      // eslint-disable-next-line no-param-reassign
      path = `${path}${generateQueryUri(params)}`;
    }

    return $http(config?.baseURL)
      .get(path, config)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(({ response }) => {
        return Promise.reject(response);
      });
  }

  async delete(path, body = {}, config = {}) {
    return $http(config?.baseURL)
      .delete(path, {
        ...config,
        headers: {
          'Content-Type': 'application/json',
          ...(config?.headers ?? {}),
        },
        data: body,
      })
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(({ response }) => {
        return Promise.reject(response);
      });
  }

  async put(path, data = {}, config = {}) {
    return $http(config?.baseURL)
      .put(path, data, config)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(({ response }) => {
        return Promise.reject(response);
      });
  }
}
